import { Avatar, Box, Typography } from '@mui/material';
import { paths } from '@common/types';
import BusinessIcon from '@mui/icons-material/Business';
import { t } from 'i18next';
import { formatDateShort } from '@util/date';

export interface AssignmentListItemProps {
  assignment: paths[`/profile/{user_id}`]['get']['responses']['200']['content']['application/json']['assignments'][number];
}

export const AssignmentListItem = ({ assignment }: AssignmentListItemProps) => {
  return (
    <Box sx={{ display: 'flex', width: '100%', gap: '1rem' }}>
      {assignment.image?.thumbnail_xsmall ? (
        <img
          alt='Logo'
          src={assignment.image?.thumbnail_xsmall}
          height={'28px'}
          width={'28px'}
          style={{
            marginTop: '0.75rem',
          }}
        />
      ) : (
        <Avatar sx={{ height: 28, width: 28, mt: '0.75rem' }}>
          <BusinessIcon />
        </Avatar>
      )}

      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant='body1' sx={{ fontWeight: 'normal' }}>
          {assignment.record.name}
        </Typography>
        <Typography
          variant='body2'
          sx={{ color: theme => theme.palette.semiBlack.main }}
        >
          {assignment.type}
        </Typography>
        <Typography
          variant='body2'
          sx={{ color: theme => theme.palette.semiBlack.main }}
        >
          {t('profile.detailsCard.assignmentsSince')}{' '}
          {formatDateShort(assignment.assignment_date)}
        </Typography>
      </Box>
    </Box>
  );
};
